<template>
  <div class="vue-modal-mask" name="fade">
    <div class="vue-modal-tutorial" tabindex="-1" role="dialog">
      <div class="vue-modal-dialog">
        <div class="vue-modal-content" id="1" v-if="tabNumber === 1">
          <div
            class="text-left mb-3"
            v-if="success"
            :style="{background: 'lightgreen', border: '1px solid green', borderRadius: '4px', padding: '10px 15px', color: 'green'}"
          >Thanks! Your request has been sent. Someone from our sales team will be in touch with you soon.</div>
          <div class="vue-modal-header">
            <h1 class="vue-modal-title">Welcome to our Journey Builder Demo!</h1>
          </div>
          <div class="vue-modal-body">
            <p class="vue-modal-paragraph">Here is a quick video to get you started with the basics.</p>

            <div class="tutorial-video">
              <b-embed
                type="iframe"
                aspect="16by9"
                src="https://www.youtube.com/embed/ydUlxva1Xx0"
                allowfullscreen
              ></b-embed>
            </div>
            <div class="vue-modal-footer modal_buttons" name="fade">
              <button class="secondary-btn right" @click="next">Next</button>
            </div>
          </div>
        </div>
        <div class="vue-modal-content" id="2" v-if="tabNumber === 2">
          <div class="vue-modal-header">
            <h1 class="vue-modal-title">Time for the good stuff…</h1>
          </div>
          <div class="vue-modal-body">
            <p
              class="vue-modal-paragraph"
            >Now that you have the basics down, pick your industry and we will show an example that benefit you and your customers.</p>
            <div class="vue-modal-industry">
              <div class="industry-list" v-for="(industry, i) in industries" :key="i">
                <button
                  class="industry-button"
                  :aria-label="`${industry}`"
                  v-on:click="whichIndustry(`${industry}`)"
                  name="fade"
                >{{industry}}</button>
              </div>
            </div>

            <div class="tutorial-video">
              <b-embed type="iframe" aspect="16by9" :src="emitVideoOfIndustry" allowfullscreen></b-embed>
            </div>
            <div class="vue-modal-footer modal_buttons" name="fade">
              <button class="secondary-btn left" @click="prev">Previous</button>
              <button
                class="btn_maropost right"
                v-on:click.stop="close"
                v-on:click="emitToParent(`${chosenIndustry}`)"
                :disabled="hide == false"
                name="fade"
                aria-label="Close"
              >Lets Do This!</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Tutorial",
  data() {
    return {
      success: false,
      alt: "Journey Builder",
      currentNumber: 0,
      industries: [
        "Publishing",
        "Ecommerce",
        "Consumer Goods",
        "Travel & Tourism"
      ],
      industryVideo: [
        { Publishing: "https://www.youtube.com/embed/DQWNhQAOWjk" },
        { Ecommerce: "https://www.youtube.com/embed/mIEhsn_jjEU" },
        { "Consumer Goods": "https://www.youtube.com/embed/8at7sKdU_7k" },
        { "Travel & Tourism": "https://www.youtube.com/embed/FW9k3Qbm_zo" }
      ],
      chosenIndustry: "",
      industryData: "",
      hide: false,
      tabNumber: 1,
      video: ""
    };
  },
  methods: {
    next() {
      this.tabNumber++;
    },
    prev() {
      this.tabNumber--;
    },
    whichIndustry(industry) {
      if (typeof industry !== "undefined") {
        this.chosenIndustry = industry;
        this.$emit("setIndustry", this.chosenIndustry);
        this.hide = true;
      }
    },
    emitToParent(data) {
      if (typeof data !== "undefined") {
        this.industryData = data;
        this.$emit("setContent", this.industryData);
      }
    },
    close() {
      this.$emit("closeTutorialModal");
      this._isDestroyed = true;
    }
  },
  computed: {
    emitVideoOfIndustry() {
      this.video = "https://www.youtube.com/embed/ydUlxva1Xx0"; // Default

      for (let i = 0; i < this.industryVideo.length; i++) {
        let industries = this.industryVideo[i];
        for (let segment in industries) {
          if (industries.hasOwnProperty(this.chosenIndustry)) {
            this.video = industries[segment];
          }
        }
      }

      return this.video;
    }
  },

  mounted() {
    if (window.location.search.indexOf("ref=success") > -1) {
      this.success = true;
    }
  }
};
</script>

<style scoped lang="scss">
$maropost_blue: #03b6fc;
.vue-modal-tutorial {
  background-color: #fff;
  width: 830px;
  border-radius: 8px;
  -webkit-box-shadow: 0px 6px 20px #00000026;
  -moz-box-shadow: 0px 6px 20px #00000026;
  box-shadow: 0px 6px 20px #00000026;
  padding: 3rem 4rem;
  margin: 0 auto;
  display: table;
  position: absolute;
  left: 0;
  top: 50%;
  right: 0;
  bottom: 0;
  height: auto;
  overflow: visible;
  vertical-align: middle;
  box-sizing: border-box;
  transform: translateY(-50%);
  .vue-modal-title {
    font-size: 1.9rem;
    font-family: $montserrat "Semibold", sans-serif;
    color: $black;
    //letter-spacing: 1px;
    font-weight: bold;
    margin: 0 0 3px 0;
  }
  .vue-modal-dialog {
    margin: 0 auto;
    font-weight: 5080;
    .vue-modal-body {
      margin: 0px 0;
      .image-slider {
        height: 400px;
        position: relative;
      }
      .tutorial-video {
        margin-bottom: 15px;
      }
      .vue-modal-paragraph {
        max-width: 75%;
        margin: 0 auto 1.5rem;
        font-size: 16px;
        color: #1e2533;
        font-family: $open_sans "Semibold", sans-serif;
      }
      .vue-modal-industry {
        margin: 0 0 1.5rem;
        .industry-list {
          display: inline-block;
          .industry-button {
            padding: 6px 20px;
            background-color: $blue-lighter;
            border: none;
            color: #006baf;
            font-weight: 500;
            letter-spacing: 1px;
            border-radius: 40px;
            outline: none;
            margin: 0 5px;
            transition: all 0.5s;
            &:hover {
              background-color: #03b6fc;
              color: #fff;
            }
            &:active,
            &:focus {
              background-color: #03b6fc;
              color: #fff;
            }
          }
        }
      }
    }
    img {
      position: relative;
      display: inline-block;
    }
    .modal-close {
      box-sizing: border-box;
      cursor: pointer;
      color: #000;
      font-size: 1.8rem;
      font-weight: 500;
      display: block;
      position: relative;
      border: transparent;
    }
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease;
  overflow: hidden;
  display: block;
  width: auto;
  visibility: visible;
  opacity: 1;
  position: absolute;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
  visibility: hidden;
  display: block;
  width: auto;
}
</style>
